var exports = {
  "A": "xaee3c4fa--6eca76--advantage",
  "h": "xaee3c4fa--6eca76--advantage__content",
};

module.exports = exports;
